































import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import { escapeHtml } from '@/helpers/html'

const basePath = process.env.VUE_APP_KEYVUE_BACKEND_BASEPATH || ''
const baseUrl = process.env.VUE_APP_KEYVUE_BACKEND_BASEURL

@Component
export default class UserPasswordReset extends Vue {
    email: string = ''
    loading: boolean = false

    async requestResetPassword(): Promise<void> {
        try {
            this.loading = true
            await axios.post(`${baseUrl}/reset_password`, {
                email: this.email,
                origin: 'keyvue',
            })
            await this.$router.push({
                name: 'user_reset_password_success',
            })

        } catch (error) {
            this.$notify({
                type: 'error',
                text: escapeHtml(error.message),
            })

        } finally {
            this.loading = false
        }
    }
}
